import {PdfTemplateDescriptor} from "./PdfTemplateDescriptor";

export class InvoicePdfTemplateDescriptor implements PdfTemplateDescriptor {

    public dynamicFields = [
            {key: "number", type: "value", attribute: "number"},
            {key: "invoiceReferenceNumber", type: "value", attribute: "invoiceReferenceNumber"},
            {key: "price", type: "value", attribute: "price", format: "price"},
			{key: "priceWithoutVat", type: "value", attribute: "priceWithoutVat", format: "price"},
			{key: "vat", type: "value", attribute: "vat", format: "price"},
            {key: "customerName", type: "value", attribute: "customerName"},
            {key: "customerAddress", type: "value", attribute: "customerAddress"},
            {key: "customerVatId", type: "value", attribute: "customerVatId"},
			{key: "customerLegalId", type: "value", attribute: "customerLegalId"},
			{key: "customerRepresentative", type: "form.reference", referenceName:"clients.complete", referenceKey: "clientId",  attribute: "representative"},
            {key: "customerInternalId", type: "form.reference", referenceName:"clients.complete", referenceKey: "clientId",  attribute: "internalId"},
            {key: "contractNumber", type: "form.reference", referenceName:"contracts.complete", referenceKey: "contractId",  attribute: "number"},
            {key: "invoiceDueDate", type: "form", attribute: "dueDate", format: "paymentDate"},
            {key: "invoiceSupplyDate", type: "form", attribute: "deliveryDate", format: "paymentDate"},
            {key: "invoiceDate", type: "form", attribute: "issueDate", format: "paymentDate"},
            {key: "itemsTable", type: "system.lookupTable", attribute: "invoiceItems"},
			{key: "tenantName", type: "value", attribute: "tenantName"},
			{key: "tenantAddress", type: "value", attribute: "tenantAddress"},
			{key: "tenantVatId", type: "value", attribute: "tenantVatId"},
			{key: "tenantCompanyId", type: "value", attribute: "tenantCompanyId"},
			{key: "tenantAccountNumber", type: "value", attribute: "tenantAccountNumber"},
			{key: "tenantInvoiceText", type: "value", attribute: "tenantInvoiceText"},
			{key: "tenantInvoiceResponsible", type: "value", attribute: "tenantInvoiceResponsible"},
			{key: "footerImage", type: "value", attribute: "footerImage"},
			{key: "headerImage", type: "value", attribute: "headerImage"},
	];

    public pdfTemplate = {

        pageMargins: [ 50, 90, 60, 80 ],
        header: {
            stack: [
                {image: '{{headerImage}}',
                    width: 590,
                    style: 'header'
                }
            ],
        },
        footer: {
            stack: [
                '\n\n',
                {image: '{{footerImage}}',
                    width: 590,
                    style: 'footer'
                }
            ],
        },
        content: [
            {stack: [
                {
                    style: 'tabelaCustomer',
                    table: {
                        widths: [300, 80, 160],
                        body: [
                            [ {text: 'Kupac:', style: 'podebljano',}, '', ''],
                            [ {text: '{{customerName}},\nAdresa: {{customerAddress}}\nPIB: {{customerVatId}}\nMatični broj: {{customerLegalId}}',  rowSpan:3}, {text:'Datum izdavanja:', style: 'podebljano',}, {text: '{{invoiceDate}}',  } ],
                            [  '', {text:'Datum prometa:', style: 'podebljano',}, {text: '{{invoiceSupplyDate}}',  } ],
                            [  '', {text:'Datum valute ', style: 'podebljano',}, {text: '{{invoiceDueDate}}',  } ],
                            [  '', {text:'ID kupca:', style: 'podebljano',}, {text: '{{customerInternalId}}',  } ],
                        ]
                    },
                    layout: 'noBorders'
                },
                {
                    text: 'Broj računa: {{number}}\n\n',
                    style: 'podebljano'
                },
                {
                    text: 'Poziv na broj: {{invoiceReferenceNumber}}\n\n',
                    style: 'podebljano'
                },
                {
                    style: 'tabelaVat',
                    table: {
                        body: [
                            [ {text: 'PIB: {{tenantVatId}}', style: 'podebljano',}, '', {text: 'MB: {{tenantCompanyId}}', style: 'podebljano'}, '', {text: 'Tekući račun: {{tenantAccountNumber}}', style: 'podebljano'}],
                        ]
                    },
                    layout: 'noBorders'
                },
                {
                    style: 'tableExample',
                    table: {
                        widths: [20, 110, 45, 30, 70, 70, 70],
                        tableBodyToFill: "itemsTable",
                        tableBodyTemplate:  [{fillColor: '#dddddd', text: '{{ROW_NUMBER}}', style: 'podebljano'}, {text: '{{title}}'}, {text:'{{unitName}}'}, {text: '{{amount}}',  }, {text: '{{unitPrice}}', alignment:'right', format: "price" }, {text: '{{vatValue}}', alignment:'right', format: "price" }, {text: '{{price}}', alignment:'right', format: "price" },],
                        body: [
                            [{border: [false, false, false, false],text: ''}, {fillColor: '#dddddd', text: 'Usluga', style: 'podebljano'}, {fillColor: '#dddddd', text: 'Jed.', style: 'podebljano'}, {fillColor: '#dddddd', text: 'Kol.', style: 'podebljano'}, {fillColor: '#dddddd', text: 'Neto po jed.', style: 'podebljano'}, {fillColor: '#dddddd', text: 'PDV', style: 'podebljano'}, {fillColor: '#dddddd', text: 'Ukupno', style: 'podebljano'},]]
                    },
                },
                {
                    table: {
                        widths: [20, 110, 45, 30, 70, 70, 70],
                        body: [
							[{border: [false, false, false, false],text: 'Poreska osnovica', alignment: 'right', colSpan: 5}, '', '','','',{text: '', style: 'podebljano', alignment:'right', },{text: '{{priceWithoutVat}}', style: 'podebljano', alignment:'right', },],
							[{border: [false, false, false, false],text: 'PDV', alignment: 'right', colSpan: 5}, '', '','','',{text: '{{vat}}', style: 'podebljano', alignment:'right', },{text: '', style: 'podebljano', alignment:'right', },],
                            [{border: [false, false, false, true],text: 'Ukupno', style: 'podebljano', alignment: 'right', colSpan: 5}, '', '','','',{text: '', alignment:'right' },{text: '{{price}}', style: 'podebljano', alignment:'right' },],
                        ]
                    },
                },
                '\n',
                {
                    text: '{{tenantInvoiceText}}',
                    style: ''
                },
                {
                    style: 'tabelaSignature',
                    table: {
                        widths: [300, 180, ],
                        body: [
                            [ {text: 'Kupac:\n\n\n', style: 'podebljano', alignment: 'left' }, {text:'{{tenantName}}', style: 'podebljano', alignment: 'left'},  ],
                            [ {text: 'Potpis: _____________________', alignment: 'left', rowSpan:2 }, {text:'____________________________________', style: 'podebljano', alignment: 'left'},  ],
                            [  '', {text:'{{tenantInvoiceResponsible}}', style: 'podebljano', alignment: 'left'},  ],
                        ]
                    },
                    layout: 'noBorders'
                },
            ],
                fontSize: 10,
            },
        ],
        styles: {
            header: {
                fontSize: 18,
                alignment: 'center',
            },
            subheader: {
                fontSize: 15,
                bold: true,
                alignment: 'center'
            },
            jstfy: {
                alignment: 'justify'
            },
            podebljano: {
                bold: true
            },
            tabelaCustomer: {
                margin: [0, 50, 50, 30,]
            },
            tabelaVat: {
                margin: [0, 0, 0, 20,]
            },
            tabelaSignature: {
                margin: [0, 20, 0, 20,]
            },
            footer: {
                fontSize: 8,
                alignment: 'center',
            },
        }
    }
}
